/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';

export const dispoGetUser = createAction(
    'dispo/get-users',
    () => ({})
);

export const dispoStoreUser = createAction(
    'dispo/store-users',
    (users) => ({users})
);

export const dispoTaskUpdate = createAction(
    'dispo/task-update',
    (id, data) => ({id, data})
);

export const dispoGetDepartments = createAction(
    'dispo/get-departments',
    () => ({})
);

export const dispoStoreDepartments = createAction(
    'dispo/store-departments',
    (departments) => ({departments})
);

export const dispoGetDepartmentsConfig = createAction(
    'dispo/get-departmentsconfig',
    ({id}) => (id)
);

export const dispoStoreDepartmentsConfig = createAction(
    'dispo/store-departmentsconfig',
    (departments) => ({departments})
);



// WEBPACK FOOTER //
// ./src/store/dispo/actions.js